import React, { useState, useEffect } from "react";

const ReactInputDelete = ({
  isOpen,
  title,
  message,
  confirmLabel,
  onConfirm,
  onCancel,
  theme,
  backgroundColor,
  textColor,
  borderColor,
}) => {
  const [inputValue, setInputValue] = useState("");

  // Reset input value when modal opens/closes
  useEffect(() => {
    if (!isOpen) {
      setInputValue("");
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleConfirm = () => {
    if (title === "Create File") {
      if (!inputValue.trim()) {
        return; // Don't proceed if input is empty
      }
      onConfirm(inputValue.trim());
    } else {
      onConfirm();
    }
    setInputValue("");
  };

  const handleCancel = () => {
    setInputValue("");
    onCancel();
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleConfirm();
    } else if (e.key === "Escape") {
      handleCancel();
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <div
        style={{
          backgroundColor: backgroundColor || "#fff",
          padding: "24px",
          borderRadius: "8px",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          width: "400px",
          maxWidth: "90%",
          border: `1px solid ${borderColor || "#e2e8f0"}`,
        }}
      >
        <h2
          style={{
            margin: "0 0 16px 0",
            fontSize: "20px",
            fontWeight: "600",
            color: textColor || "#1a202c",
          }}
        >
          {title}
        </h2>
        <p
          style={{
            margin: "0 0 20px 0",
            fontSize: "14px",
            color: textColor || "#4a5568",
            lineHeight: "1.5",
          }}
        >
          {message}
        </p>
        {title === "Create File" && (
          <input
            type="text"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="Enter file name (e.g., MyFile.js)"
            style={{
              width: "100%",
              padding: "8px 12px",
              marginBottom: "20px",
              borderRadius: "4px",
              border: `1px solid ${borderColor || "#e2e8f0"}`,
              backgroundColor: theme === "vs-dark" ? "#2d2d2d" : "#fff",
              color: textColor || "#1a202c",
              fontSize: "14px",
              outline: "none",
              border:"2px solid #1a202c"
            }}
            autoFocus
          />
        )}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "12px",
          }}
        >
          <button
            onClick={handleCancel}
            style={{
              padding: "8px 16px",
              borderRadius: "4px",
              border: `1px solid ${borderColor || "#e2e8f0"}`,
              backgroundColor: "transparent",
              color: textColor || "#4a5568",
              cursor: "pointer",
              fontSize: "14px",
              fontWeight: "500",
            }}
          >
            Cancel
          </button>
          <button
            onClick={handleConfirm}
            style={{
              padding: "8px 16px",
              borderRadius: "4px",
              border: "none",
              backgroundColor: title === "Delete File" ? "#ef4444" : "#3b82f6",
              color: "#fff",
              cursor: "pointer",
              fontSize: "14px",
              fontWeight: "500",
              opacity: title === "Create File" && !inputValue.trim() ? 0.5 : 1,
            }}
            disabled={title === "Create File" && !inputValue.trim()}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReactInputDelete;

